
import React, { useState, useEffect } from "react";
export default function ProductDetailHead(projectDetail) {

    const data = []
    const [datax, setData] = useState(data);

    useEffect(() => {
        setData(projectDetail.projectDetail);
    }, [projectDetail.projectDetail]);

    return (
        <>
            {
                datax === null ? ""
                    : <div className="relative bg-gray-50">
                        <main className="lg:relative">
                            <div className="mx-auto w-full pt-16 pb-20 text-center lg:py-48 lg:text-left pl-16">
                                <div className="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
                                    <h1 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl md:text-6xl lg:text-4xl xl:text-5xl">
                                        <span className="block xl:inline">{datax.projectHouseName}</span>{' '}
                                        {/* <span className="block text-indigo-600 xl:inline">（{datax.projectBuildingType}）</span> */}
                                    </h1>
                                    <p className="mt-3  text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-2xl">
                                        {datax.projectDesc}
                                    </p>
                                    {/* <div className="">
                                        <ul className="mt-auto pt-6 flex items-center space-x-3">
                                            <li
                                                className="rounded-full border border-black border-opacity-10 pl-2 pr-2 bg-cyan-900"
                                            >
                                                <span className="text-white">
                                                    {datax.projectBuildingStyle === 'Japan' ? "日式" : ""}
                                                    {datax.projectBuildingStyle === 'China' ? "中式" : ""}
                                                    {datax.projectBuildingStyle === 'Europe' ? "歐式" : ""}
                                                    {datax.projectBuildingStyle === 'MuJi' ? "無印風" : ""}
                                                    {datax.projectBuildingStyle === 'Modern' ? "現代風" : ""}
                                                </span>
                                            </li>

                                            <li
                                                className="rounded-full border border-black border-opacity-10 pl-2 pr-2 bg-cyan-900"
                                            >
                                                <span className="text-white">
                                                    {datax.projectArea === 'HK' ? "香港" : ""}
                                                    {datax.projectArea === 'NT' ? "新界" : ""}
                                                    {datax.projectArea === 'KL' ? "九龍" : ""}
                                                </span>
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                            </div>
                            <div className="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-3/6 lg:h-full">
                                <img
                                    className="absolute inset-0 w-full h-full object-fill"
                                    src={datax.projectCoverImg}
                                    alt=""
                                />
                            </div>
                        </main>
                    </div>
            }
        </>
    );
}